var AwayDate = (function () {
    // todo check why this differs from the header file i converted from as3
    // just made it compatible for compile right now
    function AwayDate(param1, param2, param3) {
        if (param1 === void 0) { param1 = 0; }
        if (param2 === void 0) { param2 = 0; }
        if (param3 === void 0) { param3 = 0; }
    }
    AwayDate.UTC = function (year, month, date, hour, minute, second, millisecond) {
        return 0;
    };
    AwayDate.prototype.getDate = function () { return 0; };
    AwayDate.prototype.getDay = function () { return 0; };
    AwayDate.prototype.getFullYear = function () { return 0; };
    AwayDate.prototype.getHours = function () { return 0; };
    AwayDate.prototype.getMilliseconds = function () { return 0; };
    AwayDate.prototype.getMinutes = function () { return 0; };
    AwayDate.prototype.getMonth = function () { return 0; };
    AwayDate.prototype.getSeconds = function () { return 0; };
    AwayDate.prototype.getTime = function () { return 0; };
    AwayDate.prototype.getTimezoneOffset = function () { return 0; };
    AwayDate.prototype.getUTCDate = function () { return 0; };
    AwayDate.prototype.getUTCDay = function () { return 0; };
    AwayDate.prototype.getUTCFullYear = function () { return 0; };
    AwayDate.prototype.getUTCHours = function () { return 0; };
    AwayDate.prototype.getUTCMilliseconds = function () { return 0; };
    AwayDate.prototype.getUTCMinutes = function () { return 0; };
    AwayDate.prototype.getUTCMonth = function () { return 0; };
    AwayDate.prototype.getUTCSeconds = function () { return 0; };
    AwayDate.prototype.getYear = function () { return 0; };
    AwayDate.prototype.setDate = function (date) { return 0; };
    AwayDate.prototype.setFullYear = function (year, month, date) { return 0; };
    AwayDate.prototype.setHours = function (hour) { return 0; };
    AwayDate.prototype.setMilliseconds = function (millisecond) { return 0; };
    AwayDate.prototype.setMinutes = function (minute) { return 0; };
    AwayDate.prototype.setMonth = function (month, date) { return 0; };
    AwayDate.prototype.setSeconds = function (second) { return 0; };
    AwayDate.prototype.setTime = function (millisecond) { return 0; };
    AwayDate.prototype.setUTCDate = function (date) { return 0; };
    AwayDate.prototype.setUTCFullYear = function (year, month, date) { return 0; };
    AwayDate.prototype.setUTCHours = function (hour, minute, second, millisecond) { return 0; };
    AwayDate.prototype.setUTCMilliseconds = function (millisecond) { return 0; };
    AwayDate.prototype.setUTCMinutes = function (minute, second, millisecond) { return 0; };
    AwayDate.prototype.setUTCMonth = function (month, date) { return 0; };
    AwayDate.prototype.setUTCSeconds = function (second, millisecond) { return 0; };
    AwayDate.prototype.setYear = function (year) { return 0; };
    AwayDate.prototype.toString = function () { return ""; };
    AwayDate.prototype.valueOf = function () { return 0; };
    // Mobile specific
    AwayDate.prototype.getLocaleLongDate = function () { return ""; };
    AwayDate.prototype.getLocaleShortDate = function () { return ""; };
    AwayDate.prototype.getLocaleTime = function () { return ""; };
    return AwayDate;
}());
export { AwayDate };
